import { IGalleryConfig } from '@bridebook/web/app-basic/components/supplier/sections/gallery/gallery';
import { FelaCSS, FelaCSSWithCustomSelectors, colors, spacing } from '@bridebook/ui';

interface IStyle {
  wrapper(roundCorners?: boolean): FelaCSS;
  shortlistWrapper(ctaSize: IGalleryConfig['ctaSize']): FelaCSS;
  shortlistButton(ctaSize: IGalleryConfig['ctaSize']): FelaCSS;
  prevNavButton: FelaCSSWithCustomSelectors;
  nextNavButton: FelaCSSWithCustomSelectors;
}

const navStyles: FelaCSSWithCustomSelectors = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 10,
  background: colors.white,
  padding: 2,
  opacity: 0.8,
  transition: 'all 0.1s ease-in-out',

  '&:hover': {
    opacity: 1,
  },
};

const styles: IStyle = {
  wrapper: (roundCorners) => ({
    zIndex: 2,
    ...(roundCorners && {
      '> * .alice-carousel__wrapper': {
        borderRadius: 8,
      },
    }),
  }),
  shortlistWrapper: (ctaSize) => ({
    position: 'absolute',
    zIndex: 4,
    top: spacing[4],
    right: spacing[4],
    flexDirection: 'row',
    gap: spacing[4],

    maxWidthTabletSm: {
      order: 1,
    },
    ...(ctaSize === 'small' && {
      top: spacing[2],
      right: spacing[2],
    }),
  }),
  shortlistButton: (ctaSize) => ({
    top: spacing[4],
    right: spacing[4],
    desktopDesign: {
      top: spacing[2],
      right: spacing[2],
    },
    ...(ctaSize === 'small' && {
      top: spacing[2],
      right: spacing[2],
    }),
  }),
  prevNavButton: {
    ...navStyles,
    left: 4,
    desktopDesign: {
      left: 20,
    },
  },
  nextNavButton: {
    ...navStyles,
    right: 4,
    desktopDesign: {
      right: 20,
    },
  },
};

export default styles;
